import { ExceptionModalContent, ExceptionModalContentProps } from "../../parts/exception_modal_content";

export const RequestApprovalModalStepTwo = (props: ExceptionModalContentProps) => (
  <ExceptionModalContent {...props} isEditMode />
);
